"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Gabe Kelley, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=4226%3A462))
 * @trackcomponent
 * @lastsynced 2025-04-16T17:02:15.846Z
 * @optimized using svgo:^3.0.2
 */
export const Commitment = createSVGIcon(
  <>
    <path
      d="M16.684 12.954c.516-.843.68-1.855.457-2.818-.477-2.18-3.12-3.071-4.766-1.61-.13.115-.247.248-.375.38-.128-.133-.244-.265-.374-.38-1.647-1.461-4.29-.57-4.767 1.61a3.77 3.77 0 0 0 .457 2.818c.834 1.352 2.143 2.426 3.456 3.395a2.07 2.07 0 0 0 2.456 0c1.314-.97 2.622-2.043 3.456-3.395ZM6.458 17.754a.47.47 0 0 0-.263-.706c-1.546-.464-3.588-.707-4.59-.804a.498.498 0 0 0-.548.55c.1.965.345 2.914.809 4.564a.476.476 0 0 0 .716.279c1.423-.913 2.968-2.462 3.876-3.884ZM17.542 6.246a.47.47 0 0 0 .263.706c1.546.464 3.588.707 4.59.804a.5.5 0 0 0 .548-.55c-.1-.965-.345-2.914-.809-4.564a.474.474 0 0 0-.716-.278c-1.423.912-2.968 2.461-3.876 3.882Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.383 4.019A10.8 10.8 0 0 0 11.89 1a10.8 10.8 0 0 0-7.7 3.221A11.02 11.02 0 0 0 1 12m3.617 7.981A10.8 10.8 0 0 0 12.11 23a10.8 10.8 0 0 0 7.7-3.221A11.02 11.02 0 0 0 23 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Commitment",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
